import { Banner } from '@aloft/toolkit-sui';

import { useIsScreenSupported } from '../controller/hooks/useIsScreenSupported.js';

export function UnsupportedDeviceAlert() {
  // phone is in this list because we just plain don't show the screen if you're that narrow
  const isScreenSupported = useIsScreenSupported(['phone', 'desktop', 'unconstrained']);

  if (isScreenSupported) return null;

  return (
    <Banner
      title="Device Unsupported"
      status="warning"
      canDismiss={false}
      description="Toolkit is not supported on screen widths smaller than 1024 pixels. We recommend you use this experience on your desktop or laptop"
    />
  );
}
